module.exports = __webpack_public_path__ + "static/img/shenglisige.851300c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/shop_img/shenglisige.png
// module id = HV7A
// module chunks = 1